import { css as u, LitElement as v, html as l, nothing as k } from "lit";
import { property as e, customElement as g, state as m } from "lit/decorators.js";
import { classMap as y } from "lit/directives/class-map.js";
import { b as p, f as x } from "./styles-scZ6dVz-.js";
import { b as C, a as S } from "./events-CkEPl0SM.js";
import { g as A } from "./a11y-DxQW21Jt.js";
var $ = Object.defineProperty, w = Object.getOwnPropertyDescriptor, a = (t, s, o, d) => {
  for (var i = d > 1 ? void 0 : d ? w(s, o) : s, h = t.length - 1, f; h >= 0; h--)
    (f = t[h]) && (i = (d ? f(s, o, i) : f(i)) || i);
  return d && i && $(s, o, i), i;
};
let n = class extends v {
  constructor() {
    super(...arguments), this.value = "", this.defaultValue = "";
  }
  connectedCallback() {
    super.connectedCallback(), !this.value && this.defaultValue && (this.value = this.defaultValue);
  }
  updated(t) {
    t.has("value") && this.notifyChildrenOfValueChange();
  }
  notifyChildrenOfValueChange() {
    this.dispatchEvent(new CustomEvent("ark-value-change", {
      detail: { value: this.value },
      bubbles: !1,
      composed: !1
    }));
  }
  handleTabChange(t) {
    this.value = t.detail.value, C(this, S.CHANGE, { value: this.value });
  }
  render() {
    return l`
      <div part="tabs" class="tabs" @ark-tab-select=${this.handleTabChange}>
        <slot></slot>
      </div>
    `;
  }
};
n.styles = [
  p,
  u`
      :host {
        display: block;
        height: 100%;
      }

      .tabs {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    `
];
a([
  e({ type: String, reflect: !0 })
], n.prototype, "value", 2);
a([
  e({ type: String, attribute: "default-value" })
], n.prototype, "defaultValue", 2);
n = a([
  g("ark-tabs")
], n);
let b = class extends v {
  constructor() {
    super(...arguments), this.variant = "underline";
  }
  render() {
    return l`
      <div part="list" class="list" role="tablist">
        <slot></slot>
      </div>
    `;
  }
};
b.styles = [
  p,
  u`
      :host {
        display: block;
      }

      .list {
        display: flex;
        gap: var(--r5-space-1);
        border-bottom: 1px solid var(--r5-border);
        padding-bottom: var(--r5-space-px);
      }

      /* Contained variant */
      :host([variant='contained']) .list {
        background-color: var(--r5-bg-muted);
        border-radius: var(--r5-radius-lg);
        padding: var(--r5-space-1);
        border-bottom: none;
      }
    `
];
a([
  e({ type: String, reflect: !0 })
], b.prototype, "variant", 2);
b = a([
  g("ark-tab-list")
], b);
let r = class extends v {
  constructor() {
    super(...arguments), this.triggerId = A("ark-tab"), this.value = "", this.disabled = !1, this.variant = "underline", this.badge = "", this.active = !1;
  }
  connectedCallback() {
    super.connectedCallback();
    const t = this.closest("ark-tabs");
    t && (t.addEventListener("ark-change", () => this.updateActiveState()), t.addEventListener("ark-value-change", () => this.updateActiveState())), requestAnimationFrame(() => this.updateActiveState());
  }
  updateActiveState() {
    const t = this.closest("ark-tabs");
    this.active = t?.value === this.value;
    const s = this.closest("ark-tab-list");
    s?.variant && (this.variant = s.variant);
  }
  handleClick() {
    this.disabled || this.dispatchEvent(
      new CustomEvent("ark-tab-select", {
        detail: { value: this.value },
        bubbles: !0,
        composed: !0
      })
    );
  }
  /** Returns the trigger's ID for aria-labelledby references */
  getTriggerId() {
    return this.triggerId;
  }
  updated(t) {
    t.has("value") && this.updateActiveState();
  }
  render() {
    const t = {
      trigger: !0,
      active: this.active,
      "focus-ring": !0
    };
    return l`
      <button
        part="trigger"
        class=${y(t)}
        role="tab"
        id=${this.triggerId}
        aria-selected=${this.active}
        aria-controls=${`panel-${this.value}`}
        tabindex=${this.active ? "0" : "-1"}
        ?disabled=${this.disabled}
        @click=${this.handleClick}
      >
        <slot name="icon"></slot>
        <slot></slot>
        ${this.badge ? l`<span class="badge" part="badge">${this.badge}</span>` : k}
      </button>
    `;
  }
};
r.styles = [
  p,
  x,
  u`
      :host {
        display: inline-flex;
      }

      .trigger {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: var(--r5-space-2);
        padding: var(--r5-space-2) var(--r5-space-3);
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text-muted);
        background: transparent;
        border: none;
        cursor: pointer;
        position: relative;
        transition: color var(--r5-duration-fast) var(--r5-ease-default);
        white-space: nowrap;
      }

      .trigger:hover:not(:disabled) {
        color: var(--r5-text);
      }

      .trigger:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      /* Active state - underline */
      .trigger.active {
        color: var(--ark-tab-color, var(--r5-color-primary-600));
      }

      .trigger::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: var(--ark-tab-color, var(--r5-color-primary-600));
        transform: scaleX(0);
        transition: transform var(--r5-duration-fast) var(--r5-ease-default);
      }

      .trigger.active::after {
        transform: scaleX(1);
      }

      /* Color variants */
      :host([color='blue']) { --ark-tab-color: var(--r5-color-primary-600); --ark-tab-bg: var(--r5-color-primary-100); --ark-tab-text: var(--r5-color-primary-700); }
      :host([color='amber']) { --ark-tab-color: #d97706; --ark-tab-bg: #fef3c7; --ark-tab-text: #b45309; }
      :host([color='violet']) { --ark-tab-color: #7c3aed; --ark-tab-bg: #ede9fe; --ark-tab-text: #6d28d9; }
      :host([color='emerald']) { --ark-tab-color: #059669; --ark-tab-bg: #d1fae5; --ark-tab-text: #047857; }
      :host([color='red']) { --ark-tab-color: #dc2626; --ark-tab-bg: #fee2e2; --ark-tab-text: #b91c1c; }

      @media (prefers-color-scheme: dark) {
        :host([color='blue']) { --ark-tab-color: #60a5fa; --ark-tab-bg: rgba(59, 130, 246, 0.2); --ark-tab-text: #93c5fd; }
        :host([color='amber']) { --ark-tab-color: #fbbf24; --ark-tab-bg: rgba(245, 158, 11, 0.2); --ark-tab-text: #fcd34d; }
        :host([color='violet']) { --ark-tab-color: #a78bfa; --ark-tab-bg: rgba(139, 92, 246, 0.2); --ark-tab-text: #c4b5fd; }
        :host([color='emerald']) { --ark-tab-color: #34d399; --ark-tab-bg: rgba(16, 185, 129, 0.2); --ark-tab-text: #6ee7b7; }
        :host([color='red']) { --ark-tab-color: #f87171; --ark-tab-bg: rgba(239, 68, 68, 0.2); --ark-tab-text: #fca5a5; }
      }

      /* Contained variant */
      :host([variant='contained']) .trigger {
        border-radius: var(--r5-radius-md);
      }

      :host([variant='contained']) .trigger::after {
        display: none;
      }

      :host([variant='contained']) .trigger.active {
        background-color: var(--r5-bg);
        color: var(--r5-text);
        box-shadow: var(--r5-shadow-sm);
      }

      .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-muted);
        font-size: var(--r5-text-xs);
        font-weight: var(--r5-font-medium);
        padding: 0 var(--r5-space-1-5);
        height: 1.25rem;
        min-width: 1.25rem;
        border-radius: var(--r5-radius-full);
        line-height: 1;
      }

      :host([variant='contained']) .badge {
        background-color: var(--r5-bg-surface);
      }

      .trigger.active .badge {
        background-color: var(--ark-tab-bg, var(--r5-color-primary-100));
        color: var(--ark-tab-text, var(--r5-color-primary-700));
      }
    `
];
a([
  e({ type: String, reflect: !0 })
], r.prototype, "value", 2);
a([
  e({ type: Boolean, reflect: !0 })
], r.prototype, "disabled", 2);
a([
  e({ type: String, reflect: !0 })
], r.prototype, "variant", 2);
a([
  e({ type: String, reflect: !0 })
], r.prototype, "color", 2);
a([
  e({ type: String })
], r.prototype, "badge", 2);
a([
  m()
], r.prototype, "active", 2);
r = a([
  g("ark-tab-trigger")
], r);
let c = class extends v {
  constructor() {
    super(...arguments), this.value = "", this.inactive = !0;
  }
  connectedCallback() {
    super.connectedCallback();
    const t = this.closest("ark-tabs");
    t && (t.addEventListener("ark-change", () => this.updateActiveState()), t.addEventListener("ark-value-change", () => this.updateActiveState())), requestAnimationFrame(() => this.updateActiveState());
  }
  updateActiveState() {
    const t = this.closest("ark-tabs");
    this.inactive = t?.value !== this.value;
  }
  updated(t) {
    t.has("value") && this.updateActiveState();
  }
  render() {
    const o = this.closest("ark-tabs")?.querySelector(`ark-tab-trigger[value="${this.value}"]`)?.getTriggerId() ?? `ark-tab-${this.value}`;
    return l`
      <div
        part="panel"
        class="panel"
        role="tabpanel"
        id=${`panel-${this.value}`}
        aria-labelledby=${o}
        tabindex="0"
      >
        <slot></slot>
      </div>
    `;
  }
};
c.styles = [
  p,
  u`
      :host {
        /* Hidden by default to match inactive=true default state */
        display: none;
      }

      :host(:not([inactive])) {
        /* Only show when active (inactive attribute removed) */
        display: block;
        flex: 1;
        min-height: 0;
      }

      .panel {
        height: 100%;
        box-sizing: border-box;
      }
    `
];
a([
  e({ type: String, reflect: !0 })
], c.prototype, "value", 2);
a([
  e({ type: Boolean, reflect: !0 })
], c.prototype, "inactive", 2);
c = a([
  g("ark-tab-panel")
], c);
export {
  n as A,
  b as a,
  r as b,
  c
};
//# sourceMappingURL=ark-tabs-BmEqxVFM.js.map
